import { render, staticRenderFns } from "./ModuloRepasse.vue?vue&type=template&id=5a70c482&"
import script from "./ModuloRepasse.vue?vue&type=script&lang=js&"
export * from "./ModuloRepasse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports